import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, HostListener, Input, OnInit, QueryList, SimpleChanges, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { getApiUrl } from 'src/app/core/Constants/apiList';
import { USER_TYPE, validity_date_v2 } from 'src/app/core/Constants/static';
import { ColumnSortObj } from 'src/app/core/Models/interfaces/columnSort';
import { ApiResponse } from 'src/app/core/Models/interfaces/responseData';
import { ToasterService } from '../../services/toaster.service';
import { Router } from '@angular/router';
import { UtilityService } from 'src/app/core/Services/utility.service';
import { CommonList } from 'src/app/core/Models/interfaces/commonList';
import { TabDetails } from 'src/app/core/Models/interfaces/tabDetails';
import { UserDetails } from 'src/app/core/Models/interfaces/user-details';
import { UserService } from 'src/app/core/Services/user.service';
import { CustomValidation } from '../../validators/customValidators';
import { PrescriptionService } from 'src/app/features/prescription/prescription.service';

@Component({
  selector: 'app-common-list',
  templateUrl: './common-list.component.html',
  styleUrls: ['./common-list.component.css']
})
export class CommonListComponent implements OnInit {

  @Input('tabId') id!: number;
  @Input('tabDetails') tabDetails!: CommonList;
  @Input('viewUrl') viewUrl: string = '';
  @Input('exportVar') exportVar !: number;

  @ViewChildren('focusedElement') focusedElement!: QueryList<any>;
  @ViewChild('advancedFilter') advancedFilter!: ElementRef

  private user?: UserDetails;
  private isInsideAdvacedContainer = false;
  private sortParams: string = '';

  public FilterForm !: FormGroup;
  public showAdvancedFilter = false;
  public feild_Date = validity_date_v2;
  public fetchingInProgress = false;
  public page_no = 1;
  public page_limit = 10;
  public totalCount = 10;
  public hidden = false;
  public initApiData!: TabDetails
  public dummyData: any
  public advFilter = false;
  public columnSort: ColumnSortObj = {};

  @HostListener('document:click', ['$event'])
  clickOutSideAdvancedContainer(event: Event) {
    if (!this.isInsideAdvacedContainer && !this.advancedFilter?.nativeElement.contains(event.target as Node)) {
      this.showAdvancedFilter = false;
    }
    this.isInsideAdvacedContainer = false;
  }

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private toasterandLoader: ToasterService,
    private router: Router,
    private utility: UtilityService,
    private userService: UserService,
    private prescriptionService: PrescriptionService
  ) {
    this.user = userService.getUserInfo()?.userDetails;
  }

  public ngOnInit(): void {
    this.initApiData = this.tabDetails?.tabDetails;
    this.FilterForm = this.filterArrasetting();
    // this.initialFilterSetting();
    this.apiCallForOption();
    this.hidden = true;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['exportVar']?.currentValue) {
      if (this.exportVar !== 0) {
        this.export();
      }
    }
  }

  private apiCallForOption(): void {
    if (this.initApiData) {
      this.initApiData?.filterArray?.forEach((element) => {
        if (element.type == "dropdown" && element.apiEndPoint) {
          this.getOptions(element.apiEndPoint).subscribe({
            next: (value) => {
              element.option = value.data;
            },
            error: (err) => {
            },
          })
        }
      });
    }
  }

  public sort(colName: string): void {
    if (!this.columnSort[colName]) {
      this.columnSort[colName] = {
        sortType: 'ascending',
      }
    }
    for (const key in this.columnSort) {
      if (Object.prototype.hasOwnProperty.call(this.columnSort, key)) {
        if (key == colName) {
          this.columnSort[colName].clicked = true;
          this.columnSort[colName].sortType = (this.columnSort[colName].sortType == 'ascending') ? 'descending' : 'ascending';
          this.sortParams = (this.columnSort[colName].sortType == 'descending' ? '-' : '') + colName;
        } else {
          this.columnSort[key].sortType = 'ascending';
        }
      }
    }
    this.page_no = 1;
    this.appalyFilter();
  }

  public filterArrasetting(): FormGroup {
    let fGroup = new FormGroup({}, CustomValidation.formNotNull);
    this.initApiData.filterArray.forEach((filterEle) => {
      fGroup.addControl(filterEle.controllerName, this.fb.control(null));
    })
    return fGroup
  }

  public selectedValue(event: string | null, formElem: string): void {
    if (!event) {
      this.FilterForm.controls[formElem].patchValue(null);
    }
    this.FilterForm.controls[formElem].patchValue(event);
  }

  public onAdvancedClick(event: MouseEvent): void {
    event?.stopPropagation();
    this.showAdvancedFilter = !this.showAdvancedFilter;
  }

  public onInsideAdvanceContainerClick(): void {
    this.isInsideAdvacedContainer = true;
  }

  public closeAdvanceFilter(controlName: string): void {
    this.FilterForm.controls[controlName].reset();
    this.isScrollIntoViewNeeded();
    this.appalyFilter();
  }

  private isScrollIntoViewNeeded(): void {
    setTimeout(() => {
      this.focusedElement.last?.nativeElement.scrollIntoView();
    }, 100);
  }

  public getList(): Observable<ApiResponse> {
    let url = this.initApiData.apiUrl
    if (this.user?.userType == USER_TYPE.provider) {
      url = `${this.initApiData.apiUrl}/${this.user?.providerId}`
    }
    let endpoint = getApiUrl(url, this.fliterPayload());
    return this.http.get<ApiResponse>(endpoint)
  }

  public getOptions(url: string): Observable<ApiResponse> {
    let endpoint = getApiUrl(url);
    return this.http.get<ApiResponse>(endpoint)
  }

  private fliterPayload(): Record<string, string | number | object | null> {
    let filterPayload = this.FilterForm.value;
    if (this.sortParams) {
      filterPayload['sort'] = this.sortParams;
    }
    filterPayload['page'] = this.page_no;
    filterPayload['per_page'] = this.page_limit;
    this.setSession(this.tabDetails.tabName,filterPayload);
    return filterPayload
  }

  public appalyFilter(): void {
    if (this.initApiData?.apiUrl) {
      this.toasterandLoader.isLoaderEnable(true);
      this.getList().subscribe({
        next: (res) => {
          this.toasterandLoader.isLoaderEnable(false);
          if (res?.data?.data) {
            this.dummyData = res.data.data;
            this.totalCount = res.data.total;
          }
          this.showAdvancedFilter = false;
        },
        error: (err) => {
          this.toasterandLoader.isLoaderEnable(false);
        },
      })
    }
  }

  public currentPageDetail(event: { button_no: number, item_per_page: number }): void {
    if (event) {
      this.page_no = event.button_no;
      this.page_limit = event.item_per_page;
    }
    this.isScrollIntoViewNeeded();
    this.appalyFilter();
  }

  public reset(): void {
    this.advFilter = false;
    this.FilterForm.reset();
    this.appalyFilter();
  }

  public navigateToView(item: any): void {
    this.router.navigate([this.viewUrl, item[this.initApiData.paramsForView]]);
  }

  private setSession(cname: string, cvalue: Record<string,string>) {
    this.utility.setSession(cname,JSON.stringify(cvalue));
  }
  
  private getSession(cname: string): Record<string,string|any> {
    let data = this.utility.getSession(cname);
    return data ? JSON.parse(data) : ''
  }

  private initialFilterSetting() : void {
    let cookies = this.getSession(this.tabDetails.tabName);
    if(cookies){
      this.utility.filterGroupStting(this.FilterForm,cookies)
    }
  }

  private export(): void {
    let filterPayload = this.fliterPayload();
    filterPayload['iProviderType'] = this.tabDetails.providerTypeId;
    this.prescriptionService.exportList(filterPayload)
      .pipe().subscribe({
        next: (response) => {
          this.utility.download(response, this.utility.downloadTypes.excel)
        },
        error: (error) => {
          this.toasterandLoader.alert.toast({
            title: 'Error',
            type: 'error',
            message: error.message
          });
        }
      });
  }

}
